"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MFAError = void 0;
var tslib_1 = require("tslib");
var PersistentError_1 = require("./PersistentError");
var MFAError = /** @class */ (function (_super) {
    tslib_1.__extends(MFAError, _super);
    function MFAError(token) {
        var _this = _super.call(this, 'MFA Required') || this;
        _this.token = token;
        return _this;
    }
    return MFAError;
}(PersistentError_1.PersistentError));
exports.MFAError = MFAError;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiTUZBRXJyb3IuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJNRkFFcnJvci50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7O0FBQUEscURBQW9EO0FBRXBEO0lBQThCLG9DQUFlO0lBTTNDLGtCQUFZLEtBQWE7UUFBekIsWUFDRSxrQkFBTSxjQUFjLENBQUMsU0FFdEI7UUFEQyxLQUFJLENBQUMsS0FBSyxHQUFHLEtBQUssQ0FBQzs7SUFDckIsQ0FBQztJQUNILGVBQUM7QUFBRCxDQUFDLEFBVkQsQ0FBOEIsaUNBQWUsR0FVNUM7QUFWWSw0QkFBUSJ9